import * as actionTypes from "./actionTypes";
import { API } from "../../config/config";
import { headers } from "../../ultils/helpers";

export const setProductList = (productList) => dispatch => {
  return dispatch({
    type: actionTypes.SET_PRODUCT_LIST,
    data: productList
  });
}